import { useState } from 'react';
import { useStage } from '../stage';

/** A message on a coloured background, static or scrolling as a ticker. */
export const TextItem = ({ item, startedAtMs }) => {
  const stage = useStage();
  const {
    text = '',
    color = '#FFFFFF',
    background = '#111827',
    fontSize = 96,
    align = 'center',
    scroll = false,
  } = item.settings || {};

  const style = {
    color,
    // Font sizes are authored for a 1080-pixel-high screen and scale with the stage height.
    fontSize: stage.vh((fontSize / 1080) * 100),
    lineHeight: 1.2,
    fontWeight: 600,
  };

  // Roughly constant reading speed whatever the length.
  const tickerSeconds = Math.max(8, text.length * 0.3);
  // On a wall every tile starts the scroll from the item's shared start time, so it lines up.
  // Measured once: a later re-render must not move an animation that is already running.
  const [tickerSync] = useState(() =>
    stage.wall && startedAtMs
      ? {
          animationName: 'pp-ticker-stage',
          animationDelay: `${-(((stage.now() - startedAtMs) / 1000) % tickerSeconds)}s`,
        }
      : null,
  );

  return (
    <div
      className="absolute inset-0 flex items-center overflow-hidden"
      style={{ background }}
    >
      {scroll ? (
        <span
          className="pp-ticker"
          style={{
            ...style,
            animationDuration: `${tickerSeconds}s`,
            ...tickerSync,
          }}
        >
          {text}
        </span>
      ) : (
        <div
          className="w-full whitespace-pre-wrap break-words"
          style={{ ...style, textAlign: align, padding: `0 ${stage.vw(6)}` }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
